module.exports = __webpack_public_path__ + "static/media/the-game-afl-2026.0b92b11c.webp";